"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getI18NForLocale = void 0;
const pidgin_js_1 = __importDefault(require("@lessonnine/pidgin.js"));
const locales_1 = __importDefault(require("./locales"));
const DEFAULT_LOCALE = 'en_GB';
const onMissingKey = () => { };
const i18n = new pidgin_js_1.default({ locales: locales_1.default, onMissingKey });
const getI18NForLocale = (locale) => {
    const localeIsValid = Object.keys(locales_1.default).includes(locale);
    i18n.configure({ locale: localeIsValid ? locale : DEFAULT_LOCALE, onMissingKey });
    return i18n;
};
exports.getI18NForLocale = getI18NForLocale;
//# sourceMappingURL=translations.js.map